import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ChevronDownTriangle = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.53413 6.83203C5.83243 6.83203 5.44488 7.64623 5.88737 8.19083L7.35373 9.99556C7.68719 10.406 8.31373 10.406 8.64726 9.99556L10.1136 8.19083C10.5561 7.64623 10.1685 6.83203 9.46679 6.83203H6.53413Z"
        fill={color}
      />
    </svg>
  ),
)

ChevronDownTriangle.displayName = 'ChevronDownTriangle'

ChevronDownTriangle.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default ChevronDownTriangle
